/**
 * Viewpoint stage-application module.
 * Orchestrates the planner and stage-writer so each AI-authored viewpoint tool can
 * become a concrete Jig camera only when planning produced a valid result.
 */
import type { ViewpointSceneContext, ViewpointToolData } from '../generate-jig.types'
import { planViewpoint } from './plan-viewpoint'
import { writeViewpointToStage } from './write-viewpoint-to-stage'

/**
 * Runs the full viewpoint pipeline for each AI-authored viewpoint tool on a stage.
 * Each tool is planned against the optional scene context first, then written back
 * into the Jig stage only when a concrete camera solution was produced.
 */
export function applyViewpointToStage(
  stage: any,
  viewpointTools: ViewpointToolData[],
  sceneContext: ViewpointSceneContext | null
): void {
  if (!stage || !Array.isArray(viewpointTools) || viewpointTools.length === 0) {
    return
  }

  viewpointTools.forEach(function (tool: ViewpointToolData) {
    const plannedViewpoint = planViewpoint(tool, sceneContext)
    if (
      !plannedViewpoint ||
      !plannedViewpoint.cameraPosition ||
      !plannedViewpoint.targetPosition ||
      typeof plannedViewpoint.distance !== 'number'
    ) {
      return
    }

    writeViewpointToStage(
      stage,
      plannedViewpoint.cameraPosition,
      plannedViewpoint.targetPosition,
      plannedViewpoint.distance
    )
  })
}
